import { fromJS, Map } from 'immutable';

import * as actionTypes from 'store/actions/actionTypes';
import Analytics from 'utils/analytics';

const analytics = new Analytics();

const initialState = fromJS({
  drawingMode: false,
  visibleLayers: [],
  leftSplitLayer: null,
  rightSplitLayer: null,
  clickedBoundary: undefined,
  viewPort: null,
  batchClickedBoundaries: Map(),
  hiddenLayerClasses: Map(), // Map of layerId -> Set of hidden class IDs
});

const enableDrawingMode = (state, action) => state.merge({
  drawingMode: action.enable,
});

const boundarySelected = (state, options) => {
  const clickedBoundary = fromJS({
    geoJson: options.geoJson,
  });
  return state.merge({ clickedBoundary });
};

const toggleLayer = (state, options) => {
  const index = state.get('visibleLayers').indexOf(options.layerId);
  if (index < 0) {
    if (analytics) analytics.logEvent('Layer', options.layerId);
    return state.merge({
      visibleLayers: state.get('visibleLayers').push(options.layerId),
    });
  }
  return state.merge({
    visibleLayers: state.get('visibleLayers').delete(index),
  });
};

const setViewPort = (state, action) => state.merge(
  { viewPort: fromJS(action.boundingBox) },
);

const setLeftSplitLayer = (state, action) => state.merge(
  { leftSplitLayer: action.layerId }
)

const setRightSplitLayer = (state, action) => state.merge(
  { rightSplitLayer: action.layerId }
)

const addBatchBoundary = (state, action) => {
  const boundaryId = action.boundaryId.toString();
  return state.setIn(
    ['batchClickedBoundaries', boundaryId],
    fromJS(action.geoJson)
  );
};

const removeBatchBoundary = (state, action) => {
  const boundaryId = action.boundaryId.toString();
  return state.deleteIn(['batchClickedBoundaries', boundaryId]);
};

const resetBatchBoundaries = (state) => state.merge({
  batchClickedBoundaries: Map(),
});

const toggleLayerClass = (state, action) => {
  const { layerId, classId, isVisible } = action;
  
  // Initialize the set of hidden classes for this layer if it doesn't exist
  if (!state.getIn(['hiddenLayerClasses', layerId])) {
    state = state.setIn(['hiddenLayerClasses', layerId], fromJS([])); 
  }
  
  const hiddenClasses = state.getIn(['hiddenLayerClasses', layerId]);
  
  if (isVisible) {
    // Remove classId from hidden classes
    const index = hiddenClasses.indexOf(classId);
    if (index >= 0) {
      return state.setIn(
        ['hiddenLayerClasses', layerId],
        hiddenClasses.delete(index)
      );
    }
  } else {
    // Add classId to hidden classes if not already there
    if (hiddenClasses.indexOf(classId) === -1) {
      return state.setIn(
        ['hiddenLayerClasses', layerId],
        hiddenClasses.push(classId)
      );
    }
  }
  
  return state;
};

const mapreducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ENABLE_DRAWING_MODE:
      return enableDrawingMode(state, action);
    case actionTypes.BOUNDARY_SELECT:
      return boundarySelected(state, action);
    case actionTypes.TOGGLE_MAP_LAYER:
      return toggleLayer(state, action);
    case actionTypes.SET_VIEWPORT:
      return setViewPort(state, action);
    case actionTypes.SET_LEFT_SPLIT_LAYER:
      return setLeftSplitLayer(state, action);
    case actionTypes.SET_RIGHT_SPLIT_LAYER:
      return setRightSplitLayer(state, action);
    case actionTypes.ADD_BATCH_BOUNDARY:
      return addBatchBoundary(state, action);
    case actionTypes.REMOVE_BATCH_BOUNDARY:
      return removeBatchBoundary(state, action);
    case actionTypes.RESET_BATCH_BOUNDARIES:
      return resetBatchBoundaries(state, action);
    case actionTypes.TOGGLE_LAYER_CLASS:
      return toggleLayerClass(state, action);
    case actionTypes.CLEAR_MAP:
      return initialState;
    default:
      return state;
  }
};

export default mapreducer;
